import { render, staticRenderFns } from "./EscanerPedidos.vue?vue&type=template&id=760c67f4&scoped=true&"
import script from "./EscanerPedidos.vue?vue&type=script&lang=js&"
export * from "./EscanerPedidos.vue?vue&type=script&lang=js&"
import style0 from "./EscanerPedidos.vue?vue&type=style&index=0&id=760c67f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760c67f4",
  null
  
)

export default component.exports